import { Link } from 'react-router-dom'

const About = () => {
    return (
        <div>
            <h4>Version 1.1.2</h4>
            <Link to="/">Go Back</Link>
        </div>
    )
}

export default About
